import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { useResume } from '../context/ResumeContext';
import { ADDITONAL_PREDEFINE_SECTIONS, MONTHS } from '../constants/constants';
import { usePopup } from '../context/PopupContext';
import { formatDate, rbDate2String } from '../helper';
import DraftEditor from './common/DraftEditor';
import { removeBodyScroll } from '../helper';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import DraggableIcon from '../assets/images/draggable-icon.svg';
const Certifications = (props) => {
  const {
    resume: {
      heading: { fname },
      certifications,
      enabled_tabs
    },
    handlers: {
      updateResumePreview,
    },
  } = useResume();
  const confirmbox = usePopup();
  let set = certifications.hasOwnProperty('set') ? certifications.set : {};
  const emptyrow = ADDITONAL_PREDEFINE_SECTIONS.certifications.struct.set.row_1
  const [checkField, setCheckField] = useState('');
  useEffect(() => {
    // if (!certifications.hasOwnProperty('set')) {
    //   let struct = { ...emptyrow };
    //   struct.content = certifications.content;
    //   updateResumePreview({ certifications: { ...certifications, set: { row_1: { ...struct } } } });
    // }

  }, []);

  const updateRow = (input, id) => {
    const row = {
      [id]: {//example certifications_1
        ...set[id],
        ...input
      }
    }
    updateResumePreview(
      { certifications: { ...certifications, set: { ...set, ...row } }, current_tab: 'additional_sections',  }
    )
  }
  const addRow = (newname = '') => {
    const id = 'row_' + Math.floor(Math.random() * 1000)
    const row = { ...emptyrow }
    /**
     * START
     * Changes to close automatically the previously opened tabs on adding a new one
     * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/530
     * Date: 2024-01-05
     */
    set = Object.keys(set).map(key => {
      return {...set[key], open: false}
    })
    /**
     * END
     */
    updateResumePreview(
      { certifications: { ...certifications, set: { ...set, [id]: { ...row } } }, current_tab: 'additional_sections',  }
    )
  }
  const deleteRow = (id) => {
    if (set.hasOwnProperty(id)) {
      let t = { ...set }
      delete t[id]
      if (!Object.keys(t).length) {//Last need to handle with default settings
        const newid = 'row_' + Math.floor(Math.random() * 1000)
        t = { [newid]: { ...emptyrow } }
      }
      updateResumePreview({ certifications: { ...certifications, set: { ...t } }, current_tab: 'additional_sections' })
    }
  }
  const fieldFocus = (e, id) => {
    setCheckField(e.target.name + '-' + id)
  }
  const fieldBlur = (e, id) => {
    setCheckField('');
  }

  const TabStatus = props => <div className="arrow-action" onClick={props.onClick}> {props.t ? <i className="icon-chevron-left"></i> : <i className="icon-right-arrow"></i>}</div>;

  const onDragEnd = result => {
    const { destination, source, draggableId } = result;
    if (!destination) return
    if (destination.droppableId === source.droppableId && destination.index === source.index) return
    const set1 = {};
    let ids = Object.keys(certifications.set), set = {};
    ids.splice(source.index, 1)
    ids.splice(destination.index, 0, draggableId)
    ids.forEach(element => {
      const id = 'row_' + Math.floor(Math.random() * 1000)
      set1[id] = { ...certifications.set[element] }
      //set1.push( { ...section.grid[element] })
      })
    updateResumePreview(
      { 
        certifications: { 
          ...certifications, 
          set: {...set1},
        }, current_tab: 'additional_sections',  }
    )    
}

  return (<DragDropContext onDragEnd={onDragEnd}>
  <div className="editor-form certifications-blocks">
  <Droppable droppableId={'unrelavent'}>
    {(provided) => (
    <div 
      ref={provided.innerRef} 
      {...provided.droppableProps}
      >
      {Object.keys(set).map((id, index) => (
         <Draggable draggableId={id} index={index} key={id}>
          {(provided, snapshot) => (
          <div className="sub-list-wrap" key={id} ref={provided.innerRef} {...provided.draggableProps}>
            <div className="sub-list" onClick={() => (updateRow({ open: !set[id].open }, id))}>
            <div className='addtiaonl-section-reorder'>
                  <div className="reorder">
                          <div type="button" className="btn btn-link" dataid={id} {...provided.dragHandleProps}><DraggableIcon /></div>
                  </div>
                <span className="sub-name">{set[id].name.length ? set[id].name : 'Certificate Name'}</span>
              </div>
              <div className="controls">
                <div className="delete-action">
                  <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteRow(id)), removeBodyScroll(true)}}>
                    <DeleteIcon />
                  </span>
                </div>
                <TabStatus t={set[id].open} onClick={() => (updateRow({ open: !set[id].open }, id))} />
              </div>
            </div>
            {set[id].open && <div className="sub-form">
              <div className="form-row column-2">
              
                <div className="field-wrap">
                  {/* <label htmlFor="name" className={`label${checkField == 'name-' + id ? ' label-focus' : ''}`}>Certificate Name</label> */}
                  <input
                    placeholder="Certificate Name"
                    type="text"
                    name="name"
                    onChange={(e) => {
                      updateRow({ name: e.target.value }, id)
                      //e.target.value
                    }}
                    value={set[id].name}
                    onFocus={(e) => fieldFocus(e, id)}
                    onBlur={(e) => fieldBlur(e, id)}
                  />
                </div>
                <div className="field-wrap">
                  {/* <label htmlFor="institution" className={`label${checkField == 'institution-' + id ? ' label-focus' : ''}`}>Institution</label> */}
                  <input
                    placeholder="Institution"
                    type="text"
                    name="institution"
                    onChange={(e) => {
                      updateRow({ institution: e.target.value }, id)
                      //e.target.value
                    }}
                    value={set[id]?.institution}
                    onFocus={(e) => fieldFocus(e, id)}
                    onBlur={(e) => fieldBlur(e, id)}
                  />
                </div>
                
              </div>
              <div className="form-row">
                <div className="field-wrap date-field">
                  {/* <label htmlFor="date" className={`label${checkField == 'date-' + id ? ' label-focus' : ''}`}>Certification Date</label> */}
                  <DatePicker
                    showMonthYearPicker
                    //value={}
                    placeholderText="Certification Date"
                    value={formatDate(set[id].date)}
                    selected={formatDate(set[id].date)}
                    name="date"
                    className="form-input borderaccent custom-date-picker"
                    dateFormat="MMMM yyyy"
                    disabled={false}
                    autoComplete="off"
                    onChange={e => updateRow({ date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                    onChangeRaw={e => e.preventDefault()}
                    onFocus={(e) => fieldFocus(e, id)}
                    onBlur={(e) => fieldBlur(e, id)}
                  />
                </div>
              </div>
              <div className="form-row">
              <div className="field-wrap">
                  {/* <label htmlFor="url" className={`label${checkField == 'url-' + id ? ' label-focus' : ''}`}>Certification Url</label> */}
                  <input
                    placeholder="Certification Url"
                    type="text"
                    name="url"
                    onChange={(e) => {
                      updateRow({ url: e.target.value }, id)
                      //e.target.value
                    }}
                    value={set[id]?.url}
                    onFocus={(e) => fieldFocus(e, id)}
                    onBlur={(e) => fieldBlur(e, id)}
                  />
                </div>
                </div>
              <div className="form-row">
                <div className="field-wrap">
                  <label htmlFor="description" className="label editor-label">Summary</label>
                  <DraftEditor
                    name="description"
                    // placeholder="e.g. Passionate science teacher with 8+ years of experience and a track record of..."
                    className="validate"
                    value={set[id]?.content ?? ''}
                    onInputChange={val => updateRow({ content: val }, id)}
                  />
                </div>
              </div>
              
            </div>}
          </div>
        )}
        </Draggable>
      ))}
        
      {provided.placeholder}
    </div>
    )}
     </Droppable>
    <div className="add-more-wrap">
      <span
        className="add-more-skills"
        onClick={(e) => {
          addRow()
        }}>
        <i className="icon-plus-icon"></i> Add one more
      </span>
    </div>
  </div>
  </DragDropContext>
  );
}

export default Certifications;